import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingBackgroundRemoverConfig } from '@/data/landingConfig/landingBackgroundRemoverConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_BackgroundRemover } from './schemaObject';

interface Props {}
const BackgroundRemover: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_BackgroundRemover} />
			<LandingTemplate
				data={landingBackgroundRemoverConfig}
				funnelLinkService={GenerateLandingLinkService.funnelRemoveBGV3()}
			/>
		</>
	);
};

export default BackgroundRemover;
